import {Pipe, PipeTransform} from '@angular/core';
 
@Pipe({
 name: 'currencyFormatter'
})
export class CurrencyFormatterPipe implements PipeTransform{

 transform(amount: string): string {

  if(amount && amount.indexOf("-") !=-1){
    return "("+ amount.replace('-','')  + ")";
  }
  else{
    return amount;
  }
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/currency-formatter.pipe.ts